import { BannerInformationDropdown } from "./BannerInformationDropdown";

export default BannerInformationDropdown;
